package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CommentDto(
    @SerialName("id") val id: Int,
    @SerialName("post_id") val postId: Int,
    @SerialName("user_id") val userId: Int,
    @SerialName("comment_text") val text: String? = null,  // Server sends comment_text
    @SerialName("gif_url") val gifUrl: String? = null,
    @SerialName("likes") val likes: Long = 0,
    @SerialName("replies") val replyCount: Long = 0,  // Server sends "replies" as count
    @SerialName("is_liked") val isLiked: Boolean = false,  // Server sends boolean
    @SerialName("is_pinned") val isPinned: Int = 0,
    @SerialName("user") val user: UserDto? = null,
    @SerialName("created_at") val createdAt: String,
    @SerialName("updated_at") val updatedAt: String? = null
)

@Serializable
data class ReplyCommentDto(
    @SerialName("id") val id: Int,
    @SerialName("comment_id") val commentId: Int,
    @SerialName("user_id") val userId: Int,
    @SerialName("text") val text: String? = null,
    @SerialName("gif_url") val gifUrl: String? = null,
    @SerialName("likes") val likes: Long = 0,
    @SerialName("is_liked") val isLiked: Int = 0,
    @SerialName("user") val user: UserDto? = null,
    @SerialName("created_at") val createdAt: String,
    @SerialName("updated_at") val updatedAt: String
)
